import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';
import VueSelect from "vue-select";
import { ServiceItem } from '@/services/entities/ServiceItem';
import { useSettingsStore } from '@/stores/setting';


export default /*@__PURE__*/_defineComponent({
  __name: 'TeamPropertisForm',
  props: {
    team: { Type: {} as ServiceTeamItem, required: true, default: () => ({} as ServiceTeamItem) },
},
  setup(__props) {

const settingsStore = useSettingsStore();

const props = __props;

function getItems() {
    return settingsStore.getServices.filter(s => s.isActive)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _cache[3] || (_cache[3] = _createElementVNode("label", { for: "teamName" }, "Team Name:", -1)),
      _withDirectives(_createElementVNode("input", {
        id: "teamName",
        type: "string",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.team.teamName) = $event))
      }, null, 512), [
        [_vModelText, props.team.teamName]
      ])
    ]),
    _createElementVNode("div", null, [
      _cache[4] || (_cache[4] = _createElementVNode("label", { for: "description" }, "Description:", -1)),
      _withDirectives(_createElementVNode("textarea", {
        class: "description",
        id: "description",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((props.team.description) = $event))
      }, null, 512), [
        [_vModelText, props.team.description]
      ])
    ]),
    _createElementVNode("div", null, [
      _cache[5] || (_cache[5] = _createElementVNode("label", { for: "i_serviceId" }, "Service", -1)),
      _createVNode(_unref(VueSelect), {
        id: "i_serviceId",
        label: "blServiceName",
        options: getItems(),
        clearable: false,
        reduce: (item) => item.id,
        modelValue: props.team.service.id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.team.service.id) = $event))
      }, null, 8, ["options", "reduce", "modelValue"])
    ])
  ], 64))
}
}

})